import oldage from '../Images/oldage.svg';
import care from '../Images/care.svg'
import home from '../Images/home.svg'
import rehab from '../Images/rehab.svg'
import postoperative from '../Images/postoperative.svg'
import assistedcare from '../Images/assistedcare.svg'
import comfybeds from '../Images/comfybeds.svg'
import food from '../Images/food.svg'
import wound from '../Images/wound.svg'
import therapy from '../Images/Therapy.svg'
import staff from '../Images/staff.svg'
import homecare from '../Images/homecare.svg'

export const AboutFocus = [
    {
        "id": "001",
        "title": "Consolation",
        "description": "",
        "img": "https://i.ibb.co/GQmKHnh/heart.png"
    },
    {
        "id": "002",
        "title": "Familiarity",
        "description": "",
        "img": "https://i.ibb.co/N2M8n97/love.png"
    },
    {
        "id": "003",
        "title": "Outcome",
        "description": "",
        "img": "https://i.ibb.co/t2cczRh/outcome.png"
    },
    {
        "id": "004",
        "title": "Rehabilitation",
        "description": "",
        "img": rehab
    },    
    {
        "id": "005",
        "title": "Terminal Care",
        "description": "",
        "img": care
    },
    {
        "id": "006",
        "title": "Old Age Home",
        "description": "",
        "img": home
    },
    {
        "id": "007",
        "title": "Geriatric Care",
        "description": "",
        "img": oldage
    },    
    {
        "id": "008",
        "title": "Post Operative care",
        "description": "",
        "img": postoperative
    },
    {
        "id": "009",
        "title": "Assisted Care",
        "description": "",
        "img": assistedcare
    },
    {
        "id": "010",
        "title": "Comfy Beds",
        "description": "Comfy beds marked up with ample moving space that's a cross between luxury hotel room and space",
        "link": "Read More",
        "img": comfybeds
    },
    {
        "id": "011",
        "title": "Nutritious Food",
        "description": "Well-equipped kitchen providing personalized nutritious food prepared in consultation with dieticians",
        "link": "Read More",
        "img": food
    },
    {
        "id": "012",
        "title": "Wound Managment",
        "description": "Bed-sore and wound managment facility is available with professional and well-equipped staff",
        "link": "Read More",
        "img": wound
    },
    {
        "id": "013",
        "title": "Physical Therapy",
        "description": "Customized physical therapy for speedu recovery and mobility",
        "link": "Read More",
        "img": therapy
    },
    {
        "id": "014",
        "title": "Professional Staff",
        "description": "Complete support from highly qualified professional staff and care givers",
        "link": "Read More",
        "img": staff
    },
    {
        "id": "006",
        "title": "Home Care",
        "description": "We provide home care to your beloved, and make them feel like home",
        "link": "Read More",
        "img": homecare
    },
]